import Filters from 'src/components/form/filters/filters';
import CheckboxGroup from 'src/components/form/search/filters-popup/checkbox-group';
import { WORK_EMPLOYMENT_TYPE } from 'src/constants/filters';
import { Branch, Tag, WorkFilterProps } from 'src/types';
import * as yup from 'yup';
import css from '../job-search.module.scss';

function WorkFilter({ initialValues, branches, tags, onSubmit, clear, close }: Readonly<WorkFilterProps>) {
  const validationSchema = yup.object({
    rank: yup.array().of(yup.string()),
    branch: yup.array().of(yup.string()),
    tags: yup.array().of(yup.string())
  });

  const branch = branches?.map((t: Branch) => ({ id: t.id, name: t.name })) ?? [];
  const tag = tags?.map((t: Tag) => ({ id: t.id, name: t.name })) ?? [];
  const rank = WORK_EMPLOYMENT_TYPE.map((t) => ({ id: t.id.toString(), name: t.name }));

  return (
    <Filters
      initialFilters={initialValues}
      validationSchema={validationSchema}
      fieldsToSubmitOnChange={['rank', 'branch', 'tags']}
      onSearch={onSubmit}
      render={() => (
        <div className={css.filterContainer}>
          {branch?.length > 0 && (
            <details open>
              <summary>Види/роди військ</summary>
              <section>
                <CheckboxGroup entities={branch} name='branch' title={''} />
              </section>
            </details>
          )}
          {tag?.length > 0 && (
            <details open={clear !== undefined}>
              <summary>Напрямок діяльності</summary>
              <section>
                <CheckboxGroup entities={tag} name='tags' title={''} />
              </section>
            </details>
          )}
          <details open={clear !== undefined}>
            <summary>Штатна посадова категорія: </summary>
            <section>
              <CheckboxGroup entities={rank} name='rank' title={''} />
            </section>
          </details>
          {clear !== undefined && (
            <div className={css.buttonsGroup}>
              <button onClick={close} className={css.reject}>
                Закрити
              </button>
              <button onClick={clear} className={css.reject}>
                Скинути
              </button>
            </div>
          )}
        </div>
      )}
    />
  );
}

export default WorkFilter;
